import React, { useState } from 'react';
import { FiGlobe } from 'react-icons/fi';
import { translateText } from '../services/TranslationService';
import SessionService from '../services/SessionService';
import './InternalSystemMessage.css';

interface InternalSystemMessageProps {
    id: number;
    content: string;
    sentAt?: string;
    formatTime: (ts: string) => string;
}

const InternalSystemMessage: React.FC<InternalSystemMessageProps> = ({ id, content, sentAt, formatTime }) => {
    const [translated, setTranslated] = useState<string | null>(null);
    const [showOriginal, setShowOriginal] = useState(false);
    const [isTranslating, setIsTranslating] = useState(false);
    const [translateError, setTranslateError] = useState<string | null>(null);

    const onTranslate = async () => {
        setTranslateError(null);
        if (translated) {
            setShowOriginal(prev => !prev);
            return;
        }
        const sectorId = Number(SessionService.getSectorId());
        if (!sectorId) {
            setTranslateError('No sector selected');
            return;
        }
        setIsTranslating(true);
        try {
            const result = await translateText(sectorId, content, 'pt-BR');
            setTranslated(result);
            setShowOriginal(false);
        } catch (err) {
            console.error('Translate error:', err);
            setTranslateError('Translation failed');
        } finally {
            setIsTranslating(false);
        }
    };

    const displayText = translated && !showOriginal ? translated : content;
    const buttonLabel = !translated
        ? (isTranslating ? 'Translating…' : 'Translate to PT-BR')
        : (showOriginal ? 'Show PT-BR' : 'Show original');

    return (
        <div key={id} className="internal-system-message">
            <div className="internal-system-message__bubble">
                <div className="internal-system-message__header">
                    <span className="internal-system-message__tag">
                        Internal · AI handoff summary
                    </span>
                    <button
                        type="button"
                        className="internal-system-message__translate"
                        onClick={onTranslate}
                        disabled={isTranslating}
                        aria-label={buttonLabel}
                        title={buttonLabel}
                    >
                        <FiGlobe size={12} />
                        {buttonLabel}
                    </button>
                </div>
                <div className="internal-system-message__body">{displayText}</div>
                {translateError && (
                    <div className="internal-system-message__error">{translateError}</div>
                )}
                {sentAt && (
                    <div className="internal-system-message__time">{formatTime(sentAt!)}</div>
                )}
            </div>
        </div>
    );
};

export default InternalSystemMessage;
